import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { headquartersView, journeysView, periodsView, identityView, parametersView, categoriesView, academicYearView, schoolLegalEntityView, foliosEnrollmentView, foliosEnrollmentEdit } = Views;

const configurationRouter = {
  path: "/configuration",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "legal-entity",
      name: "LegalEntity",
      component: schoolLegalEntityView,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "categories",
      name: "Categories",
      component: categoriesView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "academic-year",
      name: "AcademicYear",
      component: academicYearView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "headquarters",
      name: "Headquarters",
      component: headquartersView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "journeys",
      name: "Journeys",
      component: journeysView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "periods",
      name: "Periods",
      component: periodsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "document-types",
      name: "Identity",
      component: identityView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "folios-enrollments",
      name: "FoliosEnrollment",
      component: foliosEnrollmentView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "folios-enrollments-edit/:Id?",
      name: "FoliosEnrollmentEdit",
      component: foliosEnrollmentEdit,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "parameters",
      name: "Parameters",
      component: parametersView,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default configurationRouter;